import {ApiResponse} from "../models/api-response.model";
import {apiDelete, apiGet, apiPost, apiPut, buildPaginatedUrl} from '../utils/api.util';
import {Employee, EmployeeProject, EmployeeRole} from "../models/employee.model";
import {Company} from "./companies.servcice";
import {Project} from "../models/project.model";
import {PaginationParams} from "../models/pagination.model";

export interface EmployeeCompany extends Company {
    primary: boolean;
}

export const loadEmployees = async (params?: PaginationParams): Promise<ApiResponse<Employee[]>> => {
    const response = await apiGet(buildPaginatedUrl('/api/v1/pm/employees', params));
    return await response.json();
};

export const createEmployee = async (employee: Employee): Promise<ApiResponse<Employee>> => {
    const response = await apiPost('/api/v1/pm/employees', employee, {});
    return await response.json();
};

export const updateEmployee = async (employee: Employee): Promise<ApiResponse<Employee>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employee.id}`, employee, {});
    return await response.json();
};

export const viewEmployee = async (employeeId: number): Promise<ApiResponse<Employee>> => {
    const response = await apiGet(`/api/v1/pm/employees/${employeeId}`);
    return await response.json();
};

export const deleteEmployee = async (employeeId: number): Promise<ApiResponse<any>> => {
    const response = await apiDelete(`/api/v1/pm/employees/${employeeId}`);
    return await response.json();
};

export const assignCompaniesToEmployee = async (employeeId: number, companyIds: number[]): Promise<ApiResponse<EmployeeCompany[]>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/assign-companies`, {companyIds}, {});
    return await response.json();
}

export const unassignCompaniesFromEmployee = async (employeeId: number, companyIds: number[]): Promise<ApiResponse<EmployeeCompany[]>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/un-assign-companies`, {companyIds}, {});
    return await response.json();
}

export const setPrimaryCompany = async (employeeId: number, companyId: number): Promise<ApiResponse<EmployeeCompany[]>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/primary-company/${companyId}`, {}, {});
    return await response.json();
}

export const loadEmployeeCompanies = async (employeeId: number): Promise<ApiResponse<EmployeeCompany[]>> => {
    const response = await apiGet(`/api/v1/pm/employees/${employeeId}/companies`);
    return await response.json();
};

export const assignProjectsToEmployee = async (employeeId: number, projectIds: number[]): Promise<ApiResponse<Project[]>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/assign-projects`, {projectIds}, {});
    return await response.json();
};

export const unassignProjectsFromEmployee = async (employeeId: number, projectIds: number[]): Promise<ApiResponse<Project[]>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/un-assign-projects`, {projectIds}, {});
    return await response.json();
};

export const loadEmployeeProjects = async (employeeId: number, params?: PaginationParams): Promise<ApiResponse<EmployeeProject[]>> => {
    const response = await apiGet(buildPaginatedUrl(`/api/v1/pm/employees/${employeeId}/projects`, params));
    return await response.json();
};

export const assignRolesToEmployee = async (employeeId: number, roles: EmployeeRole[]): Promise<ApiResponse<any>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/assign-roles`, {roles}, {});
    return await response.json();
};

export const unassignRolesFromEmployee = async (employeeId: number, roles: EmployeeRole[]): Promise<ApiResponse<any>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/un-assign-roles`, {roles}, {});
    return await response.json();
};

export const uploadSignature = async (employeeId: number, signature: string): Promise<ApiResponse<Employee>> => {
    const response = await apiPut(`/api/v1/pm/employees/${employeeId}/signature`, {signature}, {});
    return await response.json();
};

export const getSignature = async (employeeId: number): Promise<ApiResponse<string>> => {
    const response = await apiGet(`/api/v1/pm/employees/${employeeId}/signature`);
    return await response.json();
};

export const deleteSignature = async (employeeId: number): Promise<ApiResponse<any>> => {
    const response = await apiDelete(`/api/v1/pm/employees/${employeeId}/signature`);
    return await response.json();
};
